import L from 'leaflet';
import 'leaflet-utfgrid/L.UTFGrid-min';

import * as layerOps from '../../api/Layers/layer-operations';

import { getPopup, whenClicked } from '../geojson-layer-style';
import getUTFGridURL from '../get-utfgrid-url';

import './customPopup';

/**
 * Builds the utfGrid layer for the map.
 *
 * @async
 * @param {object} layer - The layer object.
 * @returns {object} The leaflet utfGrid layer to add to the map or null if it isn't loaded.
 */
const buildUTFGridLayer = async layer => {
  let layerToDraw = '';
  try {
    const utfGridURL = getUTFGridURL(layer);
    layerToDraw = L.utfGrid(utfGridURL, {});
    layerToDraw.on('click', event => {
      const { latlng } = event;
      const properties = event.data;
      const { _map: leafletMap } = event.target;
      if (!event.data) {
        return false;
      }
      whenClicked({ name: layerOps.getName(layer), properties });
      L.customPopup()
        .setContent(
          getPopup({
            properties,
            styledProp: event.data.name_1,
            name: layerOps.getName(layer)
          })
        )
        .setLatLng(latlng)
        .openOn(leafletMap);
      L.DomEvent.stop(event);
      return null;
    });
    layerToDraw.on('mouseover', () => {
      document.getElementById('layerMap').style.cursor = 'pointer';
    });
    layerToDraw.on('mouseout', () => {
      document.getElementById('layerMap').style.cursor = '';
    });
    return layerToDraw;
  } catch (error) {
    console.error(error);
  }
  return null;
};

export default buildUTFGridLayer;
